import { t as __t } from "i18next";
import React, { useState, useEffect, useRef } from "react";
import { notifyListRefresh } from "../../../utils/listNavigation";
import { useDispatch, useSelector } from "react-redux";
import {
	callGenerateCode, callAddAgent,
	callEditAgent, callGetAgentById
} from "../../../api/callcenters/service"
import { callDeleteFile, callGetAllProvince, callGetDistrict, callSearchAgentInfo, callUploadFile } from "../../../api/settings/service"
import CopyrightFooter from "../../../components/footer/employers/CopyrightFooter";
import DashboardHeader from "../../../components/header/DashboardHeader";
import BackPrevious from "../../../components/back-previous";
import DashboardEmployerSidebar from "../../../components/header/DashboardSidebar";
import MobileMenu from "../../../components/header/MobileMenu";
import "../../../components/i18n/lang";
import { decodeBase64, handleGetCookie, displayUrl, FormatCurrencys, getDeviceId, relation, FormatCurrency, calculateAge, convertStringToJson } from "../../../utils/commonUtil"
import { useTranslation } from "react-i18next";
import { useParams, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import colors from '../../../utils/colors'
import moment from "moment";
import documentType from "../../../data/documentType"
import agentType from "../../../data/agentType"
import { QRCodeCanvas } from 'qrcode.react';
import { subscribeToPubNub } from '../../../utils/pubnubService';
import { toast } from "react-toastify";
import DataAutoComplete from "../../../components/auto-complete";
import { addLifeContract, callGetActivePackage, callGetContractByKey, editLifeContract, getLifeContract } from "../../../api/contract/service";
import SwalAlert from "../../../components/common/alert";
import FileUploadGrid from "../../../components/upload-file";
import { callPaymentCheckByBillNumber } from "../../../api/insurances/service";

const Index = () => {
	const userInfo = useSelector((state) => state.dataLogin);
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const { t } = useTranslation();
	const [dateOfBirth, setDateOfBirth] = useState(null);
	const [issueDate, setIssueDate] = useState(null);
	const [expiredDate, setExpiredDate] = useState(null);
	const [agent, setAgent] = useState([]);
	const [agentData, setAgentData] = useState(null);
	const saveButtonRef = useRef(null);
	const [isStickyVisible, setStickyVisible] = useState(false);
	const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms));
	const maxTime = 120;
	const [request, setRequest] = useState({
		contractNumber: null,
		insuranceType: 1,
		package: "",
		packageId: "",
		monthTotal: 1,
		optionId: '',
		isPurchaseNew: true,
		channel: 'staff on web',
		userId: userInfo?.data?.user?.userId,
		carriedCode: userInfo?.data?.user?.userId,
		carriedName: userInfo?.data?.user?.firstName + " " + (userInfo?.data?.user?.lastName === null ? '' : userInfo?.data?.user?.lastName),
		deviceId: getDeviceId(),
		customer: {
			isVerify: '',
			firstName: '',
			lastName: '',
			gender: 'm',
			dateOfBirth: '',
			age: 0,
			documentTypeId: '',
			documentNo: '',
			issueDate: '',
			expiredDate: '',
			issuePlace: '',
			documentImagePath: null,
			phone: '',
			provinceId: '',
			districtId: '',
			homeNumber: '',
			unitNumber: '',
			village: '',
			file: null,
			fileDelete: []
		},
		heirs1: {
			firstName: '',
			lastName: '',
			gender: 'm',
			relation: '',
			documentTypeId: '',
			documentNo: '',
			issueDate: '',
			expiredDate: '',
			issuePlace: '',
			documentImagePath: null,
			phone: '',
			provinceId: '',
			districtId: '',
			homeNumber: '',
			unitNumber: '',
			village: '',
			file: null,
			fileDelete: []
		},
		heirs2: {
			firstName: '',
			lastName: '',
			gender: 'm',
			relation: '',
			documentTypeId: '',
			documentNo: '',
			issueDate: '',
			expiredDate: '',
			issuePlace: '',
			documentImagePath: null,
			phone: '',
			provinceId: '',
			districtId: '',
			homeNumber: '',
			unitNumber: '',
			village: '',
			file: null,
			fileDelete: []
		}
	})
	const [selectedFile, setSelectedFile] = useState(null);
	const fileInputRef = useRef({});

	const [provinceList, setProvinceList] = useState([]);
	const [packageList, setPackageList] = useState([]);
	const [districtList, setDistrictList] = useState({ customer: [], heirs1: [], heirs2: [] });


	const [qrCode, setQRCode] = useState({
		value: '', transactionId: '', total: 0, payPerMonth: 0, feeRegister: 0, paymentFee: 0, commission: 0
	});
	let params = useParams();

	useEffect(() => {
		setRequest((prev) => ({
			...prev,
			userId: userInfo?.data?.user?.userId,
			carriedCode: userInfo?.data?.user?.userId,
			carriedName: userInfo?.data?.user?.firstName + " " + (userInfo?.data?.user?.lastName === null ? '' : userInfo?.data?.user?.lastName),
		}));
		loadProvince();
		loadPackage()
		console.log("params===", params)
		if (Object.keys(params).length > 0) {
			console.log("=================", params)
			let id = decodeBase64(params?.id)
			if (id != null) {
				setRequest((prev) => ({
					...prev, contractNumber: id
				}));
				intialData(id)
			}
		} else {
			console.log("userInfo?.data?.user?.agentId", userInfo?.data?.user)
			if (userInfo?.data?.user?.agentId) setAgentData({ agentCode: (userInfo?.data?.user?.agentId ? userInfo?.data?.user?.agentId : "") })
		}

		const handleScroll = () => {
			if (saveButtonRef.current) {
				const rect = saveButtonRef.current.getBoundingClientRect();
				setStickyVisible(rect.bottom > 980); // ปุ่มหลุดจาก view
			}
		};

		window.addEventListener('scroll', handleScroll);
		return () => window.removeEventListener('scroll', handleScroll);
	}, []);

	const [countdown, setCountdown] = useState(maxTime);

	useEffect(() => {
		if (!qrCode?.value) {
			setCountdown(maxTime);
			return;
		}

		setCountdown(maxTime);

		const timer = setInterval(() => {
			setCountdown((prev) => {
				if (prev <= 1) {
					clearInterval(timer);
					return 0;
				}

				return prev - 1;
			});
		}, 1000);

		return () => clearInterval(timer);
	}, [qrCode?.value, maxTime]);

	const formatCountdown = (seconds) => {
		const sec = Number(seconds || 0);
		const m = Math.floor(sec / 60);
		const s = sec % 60;

		return `${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}`;
	};

	const loadProvince = async () => {
		const rsp = await dispatch(callGetAllProvince());
		if (rsp?.payload?.responseCode === "00000") {
			setProvinceList(rsp?.payload?.data)
		}
	}
	const loadPackage = async () => {
		const rsp = await dispatch(callGetActivePackage());
		if (rsp?.payload?.responseCode === "00000") {
			setPackageList(rsp?.payload?.data)
		}
	}

	const intialData = async (id) => {
		const res = await dispatch(getLifeContract({ contractNumber: id }))
		if (res?.payload?.responseCode === "00000") {
			loadDistrict(res?.payload?.data?.customer?.provinceId, 'customer');
			loadDistrict(res?.payload?.data?.heirs1?.provinceId, 'heirs1');
			if (res?.payload?.data?.heirs2?.provinceId) {
				loadDistrict(res?.payload?.data?.heirs2?.provinceId, 'heirs2');
			}
			setAgentData({ agentCode: res?.payload?.data?.customer?.agentId })
			setRequest((prev) => ({
				...prev,
				packageId: res?.payload?.data?.customer?.packageId,
				optionId: res?.payload?.data?.customer?.packageMoneyOptionId,
				package: res?.payload?.data?.customer?.packageId + "_" + res?.payload?.data?.customer?.packageMoneyOptionId,
				...(res?.payload?.data),
				userId: userInfo?.data?.user?.userId,
				carriedCode: userInfo?.data?.user?.userId,
				carriedName: userInfo?.data?.user?.firstName + " " + (userInfo?.data?.user?.lastName === null ? '' : userInfo?.data?.user?.lastName),
			}));
			setRequest((prev) => ({
				...prev,
				heirs2: { ...prev.heirs2, documentImagePath: convertStringToJson(res?.payload?.data?.heirs2?.documentImagePath) },
				heirs1: { ...prev.heirs1, documentImagePath: convertStringToJson(res?.payload?.data?.heirs1?.documentImagePath) },
				customer: { ...prev.customer, documentImagePath: convertStringToJson(res?.payload?.data?.customer?.documentImagePath) }
			}));

		}
	}
	const handleChange = (e, key) => {
		const { name, value } = e.target;
		setRequest((prev) => ({
			...prev,
			[key]: {
				...prev[key],
				[name]: value
			}
		})
		);
		if (name === 'provinceId') {
			loadDistrict(e.target.value, key);
		}
	};


	const selectedDistrict = (e) => {
		e.preventDefault();
		setRequest((prev) => ({
			...prev,
			customer: {
				...prev.customer,
				districtId: e.target.value
			}
		}));
	}

	const loadDistrict = async (proId, key) => {
		const rs = await dispatch(callGetDistrict({ provinceId: proId }));
		if (rs?.payload?.responseCode === "00000") {
			setDistrictList((prev) => ({
				...prev,
				[key]: rs?.payload?.data
			}))
		}
	}

	const selectedDocument = (e) => {
		e.preventDefault();
		setRequest((prev) => ({
			...prev,
			customer: {
				...prev.customer,
				documentTypeId: e.target.value
			}
		}));
	}

	const selectePackage = (e) => {
		if (!e.target.value) {
			setRequest((prev) => ({
				...prev,
				packageId: "",
				optionId: "",
				package: ""

			}));
			return
		}
		// const data = packageList.find((item) => item.id = e.target.value)
		let item = e.target.value.split("_")
		e.preventDefault();
		const pack = packageList.find(i => i.id == item[0] && i.packageMoneyOptionId == item[1])
		if (request.customer.age < pack.ageForm || request.customer.age > pack.ageTo) {
			SwalAlert.error(__t("uiText.text023"), t("errors.ageNotPermis"));
			return
		}
		setRequest((prev) => ({
			...prev,
			packageId: item[0],
			optionId: item[1],
			package: e.target.value

		}));
	}
	const checkPaymentUntilSuccess = async (billNumber) => {
		const maxTimV = maxTime * 1000; // 1 ນາທີ
		const interval = 3 * 1000; // 3 ວິນາທີ
		const startTime = Date.now();

		while (Date.now() - startTime < maxTimV) {
			try {
				const rsp = await dispatch(callPaymentCheckByBillNumber({ billNumber: billNumber }));

				console.log("check payment result:", rsp);

				// ປັບຕາມ response ຂອງ API ເຈົ້າ
				if (rsp?.payload?.responseCode === "00000") {
					notifyListRefresh();
					navigate('/admin/contractControl/lifeInsurance')
					return {
						success: true,
						data: null,
						message: ""
					};
				}
				await sleep(interval);
			} catch (error) {
				console.log("check payment error:", error);
				await sleep(interval);
			}
		}

		return {
			success: false,
			data: null,
			message: __t("uiText.text294")
		};
	};
	const PaymentSummaryRow = ({ label, value, type = "normal", prefix = "" }) => {
		if (value === null || value === undefined || Number(value) === 0) return null;

		const isDiscount = type === "discount";
		const isTotal = type === "total";
		const isReceive = type === "receive";

		return (
			<div className={`payment-summary-row ${isTotal ? "payment-summary-total" : ""}`}>
				<div className="payment-summary-label">{label}</div>
				<div
					className={[
						"payment-summary-value",
						isDiscount ? "text-success" : "",
						isTotal ? "text-danger" : "",
						isReceive ? "text-primary" : ""
					].join(" ")}
				>
					{prefix}{FormatCurrencys(value)} {t("currentcy.kip")}
				</div>
			</div>
		);
	};
	const handleSave = async (e) => {
		e.preventDefault()
		console.log(request)
		SwalAlert.confirm(t("nameSave"), t("confirmSave"), async () => {
			try {
				if (request.contractNumber) {
					request.customer?.fileDelete?.map(async (e) => {
						await dispatch(callDeleteFile({ filePath: e.file }))
					})
					let error = null
					let documentImagePath = ""
					if (request.customer?.file && request.customer?.file !== null) {
						console.log(request.customer.file)
						const upload = await dispatch(callUploadFile(request.customer.file));
						if (upload?.payload?.responseCode === "00000") {
							if (request.customer.documentImagePath && request.customer.documentImagePath.length > 0) {
								documentImagePath = JSON.stringify([...request.customer.documentImagePath, ...upload?.payload?.data])
							} else {
								documentImagePath = JSON.stringify(upload?.payload?.data)
							}
						} else {
							error = t('uploadFile.customer')
						}
					}
					request.heirs1?.fileDelete?.map(async (e) => {
						await dispatch(callDeleteFile({ filePath: e.file }))
					})
					let heirs1DocumentImagePath = ""
					if (request.heirs1?.file && request.heirs1?.file !== null) {
						const upload = await dispatch(callUploadFile(request.heirs1.file));
						if (upload?.payload?.responseCode === "00000") {
							if (request.heirs1.documentImagePath && request.heirs1.documentImagePath.length > 0) {
								heirs1DocumentImagePath = JSON.stringify([...request.heirs1.documentImagePath, ...upload?.payload?.data])
							} else {
								heirs1DocumentImagePath = JSON.stringify(upload?.payload?.data)
							}
						} else {
							error = t('uploadFile.heirs1')

						}
					}
					request.heirs2?.fileDelete?.map(async (e) => {
						await dispatch(callDeleteFile({ filePath: e.file }))
					})
					let heirs2DocumentImagePath = ""
					if (request.heirs2?.file && request?.heirs2?.file !== null) {
						const upload = await dispatch(callUploadFile(request.heirs2.file));
						if (upload?.payload?.responseCode === "00000") {
							if (request.heirs2.documentImagePath && request.heirs2.documentImagePath.length > 0) {
								heirs2DocumentImagePath = JSON.stringify([...request.heirs2.documentImagePath, ...upload?.payload?.data])
							} else {
								heirs2DocumentImagePath = JSON.stringify(upload?.payload?.data)
							}
						} else {
							error = t('uploadFile.heirs2')
						}
					}
					let updateReq = {
						...request,
						heirs2: { ...request.heirs2, documentImagePath: heirs2DocumentImagePath ? heirs2DocumentImagePath : JSON.stringify(request.heirs2.documentImagePath) },
						heirs1: { ...request.heirs1, documentImagePath: heirs1DocumentImagePath ? heirs1DocumentImagePath : JSON.stringify(request.heirs1.documentImagePath) },
						customer: { ...request.customer, documentImagePath: documentImagePath ? documentImagePath : JSON.stringify(request.customer.documentImagePath) }
					}
					console.log(updateReq)
					const rsp = await dispatch(editLifeContract(updateReq));
					console.log(rsp)
					if (rsp?.payload?.responseCode === "00000") {
						notifyListRefresh();
					navigate('/admin/contractControl/lifeInsurance')
					} else {
						SwalAlert.error(__t("uiText.text023"), rsp?.payload?.responseCode + " - " + rsp?.payload?.responseDescription);
					}
					return
				}
				let error = null
				let documentImagePath = ""
				if (request.customer.file !== null) {
					const upload = await dispatch(callUploadFile(request.customer.file));
					if (upload?.payload?.responseCode === "00000") {
						documentImagePath = JSON.stringify(upload?.payload?.data)
					} else {
						error = `${t('uploadFile.customer')} ${upload?.payload?.responseCode || ''}`.trim()
					}
				}
				let heirs1DocumentImagePath = ""
				if (request.heirs1.file !== null) {
					const upload = await dispatch(callUploadFile(request.heirs1.file));
					if (upload?.payload?.responseCode === "00000") {
						heirs1DocumentImagePath = JSON.stringify(upload?.payload?.data)
					} else {
						error = `${t('uploadFile.heirs1')} ${upload?.payload?.responseCode || ''}`.trim()

					}
				}
				let heirs2DocumentImagePath = ""
				if (request?.heirs2?.file !== null) {
					const upload = await dispatch(callUploadFile(request.heirs2.file));
					if (upload?.payload?.responseCode === "00000") {
						heirs2DocumentImagePath = JSON.stringify(upload?.payload?.data)
					} else {
						error = `${t('uploadFile.heirs2')} ${upload?.payload?.responseCode || ''}`.trim()
					}
				}
				if (error != null) {
					SwalAlert.error(__t("uiText.text023"), error);
					return
				}
				let updateReq = {
					...request,
					userId: userInfo?.data?.user?.userId,
					carriedCode: userInfo?.data?.user?.userId,
					carriedName: userInfo?.data?.user?.firstName + " " + (userInfo?.data?.user?.lastName === null ? '' : userInfo?.data?.user?.lastName),
					heirs2: { ...request.heirs2, documentImagePath: heirs2DocumentImagePath },
					heirs1: { ...request.heirs1, documentImagePath: heirs1DocumentImagePath },
					customer: { ...request.customer, documentImagePath }
				}
				const rsp = await dispatch(addLifeContract(updateReq));
				if (rsp?.payload?.responseCode === "00000") {
					setQRCode({
						value: rsp?.payload?.data,
						transactionId: rsp?.payload?.calculate?.transactionId,
						payPerMonth: rsp?.payload?.calculate?.packagePrice,
						feeRegister: rsp?.payload?.calculate?.registerFee,
						total: rsp?.payload?.calculate?.totalAmount,
						discount: rsp?.payload?.calculate?.discount,
						vat: rsp?.payload?.calculate?.vat,
						vatValue: rsp?.payload?.calculate?.vatValue,
						commission: rsp?.payload?.calculate?.commission,
						realPackageAmount: rsp?.payload?.calculate?.realPackageAmount,
						paymentFee: rsp?.payload?.calculate?.paymentFee,
						companyReceiveTotal: rsp?.payload?.calculate?.companyReceiveTotal,
					})
					const check = await checkPaymentUntilSuccess(rsp?.payload?.calculate?.billNumber)
					if (!check.success) {
						notifyListRefresh();
					navigate('/admin/contractControl/lifeInsurance')
						return;
					}
				} else {
					SwalAlert.error(__t("uiText.text023"), rsp?.payload?.responseCode + " - " + rsp?.payload?.responseDescription);
				}
			} catch (error) {
				console.error(error)
				SwalAlert.error(__t("uiText.text023"), __t("uiText.text024"),);
			}
		})

	}

	const triggerFileInput = (key) => {
		fileInputRef.current[key].click();

	};

	const cancelSeletedFile = (key) => {
		setRequest((prev) => ({
			...prev,
			[key]: {
				...prev[key],
				file: null
			}
		}));
	};


	const handleImageDelete = async (e, key) => {
		console.log(request)
		SwalAlert.confirm(t("nameDelete"), t("confirmDelete"), async () => {
			setRequest((prev) => ({
				...prev,
				[key]: {
					...prev[key],
					documentImagePath: prev[key].documentImagePath?.filter((_, index) => index !== e.index),
					fileDelete: [...prev[key].fileDelete || [], e.file]
				}

			}));
			SwalAlert.success(t("deleteFileSuccess"))

		});
	};
	const handleImageSelect = async (e, key) => {
		setRequest((prev) => ({
			...prev,
			[key]: {
				...prev[key],
				file: e
			}
		}));
	};
	const handleDateChange = (date, field, key) => {
		setRequest((prev) => ({
			...prev,
			[key]: {
				...prev[key],
				[field]: moment(date).format('YYYY-MM-DD'),
				age: field === 'dateOfBirth' ? calculateAge(moment(date).format('YYYY-MM-DD')) : prev[key].age
			}
		}));
		console.log(date)
	};

	const loadData = async (value) => {
		if (value?.id) {
			let data = { keyword: null, page: 1, maxResult: 1, agentId: value?.id, type: 1 };
			const rsp = await dispatch(callSearchAgentInfo(data));
			if (rsp?.payload?.responseCode === "00000" && rsp?.payload?.data?.result.length >= 1) {
				setAgent(rsp.payload.data.result)
			}

		} else {
			let data = { keyword: value, page: 1, maxResult: 10, agentId: null, type: 1 };
			const rsp = await dispatch(callSearchAgentInfo(data));
			if (rsp?.payload?.responseCode === "00000" && rsp?.payload?.data?.result.length >= 1) {
				setAgent(rsp.payload.data.result)
			}
		}
	};

	const onSelect = async (item) => {
		console.log(item)
		if (item) {
			setRequest((prev) => ({
				...prev,
				agentId: item.agentId
			}));
		}
	}


	return (
		<div className="page-wrapper dashboard">
			<span className="header-span"></span>
			<DashboardHeader />
			<MobileMenu />
			<DashboardEmployerSidebar />
			<form onSubmit={handleSave}>
				<section className="user-dashboard">
					<div className="dashboard-outer">
						<div className="upper-title-box back-title-group">
							<BackPrevious />
							<h4>{Object.keys(params).length > 0 ? t("contracts.edit") : t("contracts.add")}</h4>
						</div>

						<div className="ls-widget">
							<div className="tabs-box">
								<div className="widget-content p-4">
									<div className="default-form">
										<div className="row">
											<div className="col-12 mb-3"><h5 className="fw-bold">#{t("contracts.life.customer")}</h5><hr /></div>
											<div className="col-md-3 form-group">
												<label> {t('contracts.life.agentCode')}<span className="text-danger">*</span></label>
												<DataAutoComplete
													disabled={request.contractNumber != null}
													label="firstName"
													id="agentCode"
													initialData={agentData}
													data={agent}
													autoSelect={true}
													placeholder={t('contract.keyword')}
													handleChange={loadData}
													onSelect={onSelect}
												/>
											</div>
											<div className="col-md-3 form-group">
												<label>{t('contracts.life.gender')} <span className="text-danger">*</span> </label>
												<select className="chosen-single form-select"
													name="gender"
													onChange={(e) => handleChange(e, "customer")}
													value={request.customer?.gender}
													required
												>
													<option key={"m"} value={"m"}>{t("gender.m")}</option>
													<option key={"f"} value={"f"}>{t("gender.f")}</option>
												</select>
											</div>
											<div className="col-md-3 form-group">
												<label> {t('contracts.life.firstName')}<span className="text-danger">*</span></label>
												<input
													type="text"
													name="firstName"
													className="form-control-uld"
													placeholder={t('contracts.life.firstName')}
													onChange={(e) => handleChange(e, "customer")}
													value={request.customer?.firstName}
													autoComplete="off"
													required />
											</div>

											<div className="col-md-3 form-group">
												<label> {t('contracts.life.lastName')}</label>
												<input
													type="text"
													name="lastName"
													className="form-control-uld"
													placeholder={t('contracts.life.lastName')}
													onChange={(e) => handleChange(e, "customer")}
													value={request.customer?.lastName}
													autoComplete="off"
												/>
											</div>

											<div className="col-md-3 form-group">
												<label> {t('contracts.life.dateOfBirth')} <span className="text-danger">*</span> - {t('uiLabels.ageYears', { age: request.customer?.age })} </label>
												<DatePicker
													selected={request.customer?.dateOfBirth}
													onChange={(date) => handleDateChange(date, 'dateOfBirth', "customer")}
													dateFormat="dd/MM/yyyy"
													placeholderText={t('contracts.life.dateOfBirth')}
													className="form-control-uld"
													required
												/>
											</div>
											<div className="col-md-3 form-group">
												<label> {t('contracts.life.phone')} <span className="text-danger">*</span> </label>
												<input
													type="number"
													name="phone"
													className="form-control-uld"
													placeholder={t('contracts.life.phone')}
													onChange={(e) => handleChange(e, "customer")}
													value={request.customer?.phone}
													autoComplete="off"
													required />
											</div>

											<div className="col-md-3 form-group">
												<label> {t('contracts.life.provinceName')} <span className="text-danger">*</span> </label>
												<select className="chosen-single form-select"
													name="provinceId"
													onChange={(e) => handleChange(e, "customer")}
													value={request.customer?.provinceId}
													required
												>
													<option key={0} value="">{t("pleaseSelect")}</option>
													{
														provinceList.map((item) => (
															<option key={item.provinceId} value={item.provinceId}>{item.provinceName}</option>
														))
													}
												</select>
											</div>

											<div className="col-md-3 form-group">
												<label> {t('contracts.life.districtName')} <span className="text-danger">*</span> </label>
												<select className="chosen-single form-select"
													name="districtId"
													onChange={selectedDistrict}
													value={request.customer?.districtId}
													required
												>
													<option key={0} value="">{t("pleaseSelect")}</option>
													{
														districtList['customer'].map((item) => (
															<option key={item.districtId} value={item.districtId}>{item.districtName}</option>
														))
													}
												</select>
											</div>

											<div className="col-md-3 form-group">
												<label> {t('contracts.life.village')} <span className="text-danger">*</span> </label>
												<input
													type="text"
													name="village"
													className="form-control-uld"
													placeholder={t('contracts.life.village')}
													onChange={(e) => handleChange(e, "customer")}
													value={request.customer?.village}
													autoComplete="off" />
											</div>

											<div className="col-md-3 form-group">
												<label>{t('contracts.life.package')} <span className="text-danger">*</span> </label>
												<select className="chosen-single form-select"
													name="packageId"
													onChange={selectePackage}
													value={request?.package}
													required
													disabled={request.contractNumber}
												>
													<option key={0} value="">{t("pleaseSelect")}</option>
													{packageList.map((item, index) => (
														<option key={index} value={item.id + "_" + item.packageMoneyOptionId}>{item.ageRange} {t('title.year')} {FormatCurrencys(item.payPerMonth)} {t('currentcy.kip')}/{t('title.month')}</option>

													))
													}
												</select>
											</div>
											<div className="col-md-2 form-group">
												<label>{t("contracts.life.homeNumber")}</label>
												<input className="form-control-uld" placeholder={t('contracts.life.homeNumber')} name="homeNumber" value={request.customer?.homeNumber} onChange={(e) => handleChange(e, "customer")} />
											</div>

											<div className="col-md-2 form-group">
												<label>{t("contracts.life.unitNumber")}</label>
												<input className="form-control-uld" placeholder={t('contracts.life.unitNumber')} name="unitNumber" value={request.customer?.unitNumber} onChange={(e) => handleChange(e, "customer")} />
											</div>


											<div className="col-md-2 form-group">
												<label>{t('contracts.life.documentType')}<span className="text-danger">*</span></label>
												<select className="chosen-single form-select"
													name="documentTypeId"
													onChange={selectedDocument}
													value={request.customer?.documentTypeId}
												>
													<option key={0} value={""}>{t("selectedAll")}</option>
													{
														documentType.map((item) => (
															<option key={item.id} value={item.id}>{t(item.name)}</option>
														))
													}
												</select>
											</div>

											<div className="col-md-2 form-group">
												<label> {t('contracts.life.documentNo')}<span className="text-danger">*</span></label>
												<input
													type="text"
													name="documentNo"
													required
													className="form-control-uld"
													placeholder={t('contracts.life.documentNo')}
													onChange={(e) => handleChange(e, "customer")}
													value={request.customer?.documentNo}
													autoComplete="off"
												/>
											</div>

											<div className="col-md-2 form-group">
												<label> {t('contracts.life.issueDate')}</label>
												<DatePicker
													selected={request.customer?.issueDate}
													onChange={(date) => handleDateChange(date, 'issueDate', "customer")}
													dateFormat="dd/MM/yyyy"
													placeholderText={t('callcenter.agent.issueDate')}
													className="form-control-uld"
												/>
											</div>


											<div className="col-md-2 form-group">
												<label> {t('contracts.life.expiredDate')}</label>
												<DatePicker
													selected={request.customer?.expiredDate}
													onChange={(date) => handleDateChange(date, 'expiredDate', "customer")}

													dateFormat="dd/MM/yyyy"
													placeholderText={t('contracts.life.expiredDate')}
													className="form-control-uld"
												/>
											</div>
											<div className="col-md-2 form-group">
												<label> {t('contracts.life.issuePlace')}</label>
												<input
													type="text"
													name="issuePlace"
													className="form-control-uld"
													placeholder={t('contracts.life.issuePlace')}
													onChange={(e) => handleChange(e, "customer")}
													value={request.customer?.issuePlace}
													autoComplete="off" />
											</div>
											<div className="col-md-2 form-group">
												<label>{t('contracts.life.isVerify')}<span className="text-danger">*</span></label>
												<select className="chosen-single form-select"
													name="isVerify"
													onChange={(e) => handleChange(e, "customer")}
													value={request.customer?.isVerify}
													disabled={request.customer?.oldVerify === 1}
													style={request.customer.oldVerify === 1 ? { color: colors.primary } : {}}
													required
												>
													<option key={0} value={0}>{t("verifyStatus.notVerify")}</option>
													<option key={1} value={1}>{t("verifyStatus.verify")}</option>
												</select>
											</div>



											<div className="col-12 col-md-12 form-group">
												<label> {t('settings.agentSpecialCommission.documentReference')} <span className="text-danger">*</span> </label>
												<FileUploadGrid
													onDelete={(e) => handleImageDelete(e, 'customer')}
													multiple={true}
													folderName="customer"
													filesFromApi={request.customer.documentImagePath || []}
													onChange={(e) => handleImageSelect(e, 'customer')}
													accept="image/*,application/pdf"
													required
												/>
											</div>
										</div>
									</div>
								</div></div>
						</div>

						<div className="ls-widget">
							<div className="tabs-box">
								<div className="widget-content p-4">
									<div className="default-form">

										<div className="row">
											<div className="col-12 mb-3"><h5 className="fw-bold">#{t("contracts.life.heirs1")}</h5><hr /></div>
											<div className="col-md-2 form-group">
												<label>{t("contracts.life.gender")}<span className="text-danger">*</span></label>
												<select className="form-select" name="gender" value={request.heirs1.gender} required onChange={(e) => handleChange(e, "heirs1")}>
													<option value="m">{t("gender.m")}</option>
													<option value="f">{t("gender.f")}</option>
												</select>
											</div>
											<div className="col-md-3 form-group">
												<label>{t("contracts.life.firstName")}<span className="text-danger">*</span></label>
												<input className="form-control-uld" placeholder={t('contracts.life.firstName')} name="firstName" value={request.heirs1?.firstName} required onChange={(e) => handleChange(e, "heirs1")} />
											</div>
											<div className="col-md-3 form-group">
												<label>{t("contracts.life.lastName")}<span className="text-danger">*</span></label>
												<input className="form-control-uld" placeholder={t('contracts.life.lastName')} name="lastName" value={request.heirs1?.lastName} required onChange={(e) => handleChange(e, "heirs1")} />
											</div>
											<div className="col-md-2 form-group">
												<label>{t("contracts.life.relation")}<span className="text-danger">*</span></label>
												<select className="form-select" name="relation" value={request.heirs1.relation} required onChange={(e) => handleChange(e, "heirs1")}>
													<option key={0} value="">{t("pleaseSelect")}</option>
													{relation().map(item => (<option key={item.value} value={item.value}>{item.label}</option>))}
												</select>
											</div>
											<div className="col-md-2 form-group">
												<label>{t("contracts.life.age")}<span className="text-danger">*</span></label>
												<input className="form-control-uld" placeholder={t('contracts.life.age')} name="age" value={request.heirs1?.age} required onChange={(e) => handleChange(e, "heirs1")} />
											</div>
											<div className="col-md-2 form-group">
												<label>{t("contracts.life.documentType")}<span className="text-danger">*</span></label>
												<select className="form-select" name="documentTypeId" value={request.heirs1.documentTypeId} onChange={(e) => handleChange(e, "heirs1")}>
													<option value="">{t("pleaseSelect")}</option>
													{documentType.map(item => (
														<option key={item.id} value={item.id}>{t(item.name)}</option>
													))}
												</select>
											</div>
											<div className="col-md-2 form-group">
												<label>{t("contracts.life.documentNo")}<span className="text-danger">*</span></label>
												<input className="form-control-uld"
													placeholder={t('contracts.life.documentNo')}
													name="documentNo"
													value={request.heirs1.documentNo}
													required
													onChange={(e) => handleChange(e, "heirs1")} />
											</div>

											<div className="col-md-2 form-group">
												<label>{t("contracts.life.issueDate")}</label>
												<DatePicker
													selected={request.heirs1.issueDate}
													onChange={(date) => handleDateChange(date, 'issueDate', "heirs1")}
													placeholderText={t('contracts.life.issueDate')}
													dateFormat="dd/MM/yyyy"
													className="form-control-uld"
												/>
											</div>

											<div className="col-md-2 form-group">
												<label>{t("contracts.life.expiredDate")}</label>
												<DatePicker
													selected={request.heirs1.expiredDate}
													onChange={(date) => handleDateChange(date, 'expiredDate', "heirs1")}
													placeholderText={t('contracts.life.expiredDate')}
													dateFormat="dd/MM/yyyy"
													className="form-control-uld"
												/>
											</div>

											<div className="col-md-2 form-group">
												<label>{t("contracts.life.issuePlace")}</label>
												<input className="form-control-uld" placeholder={t('contracts.life.issuePlace')} name="issuePlace" value={request.heirs1.issuePlace} onChange={(e) => handleChange(e, "heirs1")} />
											</div>

											<div className="col-md-2 form-group">
												<label>{t("contracts.life.phone")}<span className="text-danger">*</span></label>
												<input className="form-control-uld" placeholder={t('contracts.life.phone')} required name="phone" value={request.heirs1.phone} onChange={(e) => handleChange(e, "heirs1")} />
											</div>

											<div className="col-md-2 form-group">
												<label>{t("contracts.life.provinceName")}<span className="text-danger">*</span></label>
												<select className="form-select" name="provinceId" value={request.heirs1.provinceId} onChange={(e) => handleChange(e, "heirs1")}>
													<option value="">{t("pleaseSelect")}</option>
													{provinceList.map(province => (
														<option key={province.provinceId} value={province.provinceId}>{province.provinceName}</option>
													))}
												</select>
											</div>

											<div className="col-md-2 form-group">
												<label>{t("contracts.life.districtName")}<span className="text-danger">*</span></label>
												<select className="form-select" name="districtId" value={request.heirs1.districtId} onChange={(e) => handleChange(e, "heirs1")}>
													<option value="">{t("pleaseSelect")}</option>
													{districtList['heirs1'].map(d => (
														<option key={d.districtId} value={d.districtId}>{d.districtName}</option>
													))}
												</select>
											</div>

											<div className="col-md-2 form-group">
												<label>{t("contracts.life.village")}<span className="text-danger">*</span></label>
												<input className="form-control-uld" placeholder={t('contracts.life.village')} required name="village" value={request.heirs1.village} onChange={(e) => handleChange(e, "heirs1")} />
											</div>

											<div className="col-md-2 form-group">
												<label>{t("contracts.life.homeNumber")}</label>
												<input className="form-control-uld" placeholder={t('contracts.life.homeNumber')} name="homeNumber" value={request.heirs1.homeNumber} onChange={(e) => handleChange(e, "heirs1")} />
											</div>

											<div className="col-md-2 form-group">
												<label>{t("contracts.life.unitNumber")}</label>
												<input className="form-control-uld" placeholder={t('contracts.life.unitNumber')} name="unitNumber" value={request.heirs1.unitNumber} onChange={(e) => handleChange(e, "heirs1")} />
											</div>
											<div className="col-12 col-md-12 form-group">
												<label> {t('settings.agentSpecialCommission.documentReference')} <span className="text-danger">*</span> </label>
												<FileUploadGrid
													onDelete={(e) => handleImageDelete(e, 'heirs1')}
													multiple={true}
													folderName="heirs1"
													filesFromApi={request.heirs1.documentImagePath || []}
													onChange={(e) => handleImageSelect(e, 'heirs1')}
													accept="image/*,application/pdf"
													required
												/>
											</div>
										</div>

									</div>
								</div></div>
						</div>

						<div className="ls-widget">
							<div className="tabs-box">
								<div className="widget-content p-4">
									<div className="default-form">
										<div className="row">
											<div className="col-12 mb-3"><h5 className="fw-bold">#{t("contracts.life.heirs2")}</h5><hr /></div>
											<div className="col-md-2 form-group">
												<label>{t("contracts.life.gender")}<span className="text-danger">*</span></label>
												<select className="form-select" name="gender" value={request.heirs2.gender} onChange={(e) => handleChange(e, "heirs2")}>
													<option value="m">{t("gender.m")}</option>
													<option value="f">{t("gender.f")}</option>
												</select>
											</div>
											<div className="col-md-3 form-group">
												<label>{t("contracts.life.firstName")}<span className="text-danger">*</span></label>
												<input className="form-control-uld" placeholder={t('contracts.life.firstName')} name="firstName" value={request.heirs2.firstName} onChange={(e) => handleChange(e, "heirs2")} />
											</div>
											<div className="col-md-3 form-group">
												<label>{t("contracts.life.lastName")}<span className="text-danger">*</span></label>
												<input className="form-control-uld" placeholder={t('contracts.life.lastName')} name="lastName" value={request.heirs2.lastName} onChange={(e) => handleChange(e, "heirs2")} />
											</div>
											<div className="col-md-2 form-group">
												<label>{t("contracts.life.relation")}<span className="text-danger">*</span></label>
												<select className="form-select" name="relation" value={request.heirs2.relation} onChange={(e) => handleChange(e, "heirs2")}>
													<option key={0} value="">{t("pleaseSelect")}</option>
													{relation().map(item => (<option key={item.value} value={item.value}>{item.label}</option>))}
												</select>
											</div>
											<div className="col-md-2 form-group">
												<label>{t("contracts.life.age")}<span className="text-danger">*</span></label>
												<input className="form-control-uld" placeholder={t('contracts.life.age')} name="age" value={request.heirs2.age} onChange={(e) => handleChange(e, "heirs2")} />
											</div>
											<div className="col-md-2 form-group">
												<label>{t("contracts.life.documentType")}<span className="text-danger">*</span></label>
												<select className="form-select" name="documentTypeId" value={request.heirs2.documentTypeId} onChange={(e) => handleChange(e, "heirs2")}>
													<option value="">{t("pleaseSelect")}</option>
													{documentType.map(item => (
														<option key={item.id} value={item.id}>{t(item.name)}</option>
													))}
												</select>
											</div>
											<div className="col-md-2 form-group">
												<label>{t("contracts.life.documentNo")}</label>
												<input className="form-control-uld" placeholder={t('contracts.life.documentNo')} name="documentNo" value={request.heirs2.documentNo} onChange={(e) => handleChange(e, "heirs2")} />
											</div>

											<div className="col-md-2 form-group">
												<label>{t("contracts.life.issueDate")}</label>
												<DatePicker
													selected={request.heirs2.issueDate}
													onChange={(date) => handleDateChange(date, 'issueDate', "heirs2")}
													placeholderText={t('contracts.life.issueDate')}
													dateFormat="dd/MM/yyyy"
													className="form-control-uld"
												/>
											</div>

											<div className="col-md-2 form-group">
												<label>{t("contracts.life.expiredDate")}</label>
												<DatePicker
													selected={request.heirs2.expiredDate}
													onChange={(date) => handleDateChange(date, 'expiredDate', "heirs2")}
													placeholderText={t('contracts.life.expiredDate')}
													dateFormat="dd/MM/yyyy"
													className="form-control-uld"
												/>
											</div>

											<div className="col-md-2 form-group">
												<label>{t("contracts.life.issuePlace")}</label>
												<input className="form-control-uld" placeholder={t('contracts.life.issuePlace')} name="issuePlace" value={request.heirs2.issuePlace} onChange={(e) => handleChange(e, "heirs2")} />
											</div>

											<div className="col-md-2 form-group">
												<label>{t("contracts.life.phone")}<span className="text-danger">*</span></label>
												<input className="form-control-uld" placeholder={t('contracts.life.phone')} name="phone" value={request.heirs2.phone} onChange={(e) => handleChange(e, "heirs2")} />
											</div>

											<div className="col-md-2 form-group">
												<label>{t("contracts.life.provinceName")}<span className="text-danger">*</span></label>
												<select className="form-select" name="provinceId" value={request.heirs2.provinceId} onChange={(e) => handleChange(e, "heirs2")}>
													<option value="">{t("pleaseSelect")}</option>
													{provinceList.map(province => (
														<option key={province.provinceId} value={province.provinceId}>{province.provinceName}</option>
													))}
												</select>
											</div>

											<div className="col-md-2 form-group">
												<label>{t("contracts.life.districtName")}<span className="text-danger">*</span></label>
												<select className="form-select" name="districtId" value={request.heirs2.districtId} onChange={(e) => handleChange(e, "heirs2")}>
													<option value="">{t("pleaseSelect")}</option>
													{districtList['heirs2'].map(d => (
														<option key={d.districtId} value={d.districtId}>{d.districtName}</option>
													))}
												</select>
											</div>

											<div className="col-md-2 form-group">
												<label>{t("contracts.life.village")}<span className="text-danger">*</span></label>
												<input className="form-control-uld" placeholder={t('contracts.life.village')} name="village" value={request.heirs2.village} onChange={(e) => handleChange(e, "heirs2")} />
											</div>

											<div className="col-md-2 form-group">
												<label>{t("contracts.life.homeNumber")}</label>
												<input className="form-control-uld" placeholder={t('contracts.life.homeNumber')} name="homeNumber" value={request.heirs2.homeNumber} onChange={(e) => handleChange(e, "heirs2")} />
											</div>

											<div className="col-md-2 form-group">
												<label>{t("contracts.life.unitNumber")}</label>
												<input className="form-control-uld" placeholder={t('contracts.life.unitNumber')} name="unitNumber" value={request.heirs2.unitNumber} onChange={(e) => handleChange(e, "heirs2")} />
											</div>
											<div className="col-12 col-md-12 form-group">
												<label> {t('settings.agentSpecialCommission.documentReference')} <span className="text-danger">*</span> </label>
												<FileUploadGrid
													onDelete={(e) => handleImageDelete(e, 'heirs2')}
													multiple={true}
													folderName="heirs2"
													filesFromApi={request.heirs2.documentImagePath || []}
													onChange={(e) => handleImageSelect(e, 'heirs2')}
													accept="image/*,application/pdf"
													
												/>
											</div>
										</div>


										{
											qrCode.total == 0 ? <div className="col-12 d-flex justify-content-center">
												<div className="m-3" ref={saveButtonRef}>
													<button className="theme-btn btn-style-one w-100" type="submit">
														<i className="fas fa-add"></i>&nbsp;{t("button.save")}
													</button>
												</div>
											</div> : null
										}
										{isStickyVisible && (
											<div className="form-footer-fixed">
												<div className="container d-flex justify-content-center">
													<button className="theme-btn btn-style-one w-auto" type="submit" onClick={() => saveButtonRef.current?.click()}>
														<i className="fas fa-add"></i>&nbsp;{t("button.save")}
													</button>
												</div>
											</div>
										)}
									</div>
								</div>
							</div>
						</div>
						{qrCode?.total ? (
							<div className="ls-widget payment-widget">
								<div className="tabs-box">
									<div className="widget-content p-4">
										<div className="payment-card">
											<div className="payment-card-header">
												<div>
													<div className="payment-title">
														{t("contracts.life.payment") || "Payment"}
													</div>
													<div className="payment-subtitle">
														{t("callcenter.agent.transactionId")}:{" "}
														<span>{qrCode.transactionId || "-"}</span>
													</div>
												</div>

												<div className="payment-status-badge">
													{countdown > 0
														? (t("payment.waitingPayment") || "Waiting payment")
														: (t("payment.expired") || "Expired")}
												</div>
											</div>

											<div className="payment-card-body">
												<div className="payment-qr-section">
													<div className="payment-qr-box">
														<QRCodeCanvas
															value={qrCode.value}
															size={260}
															bgColor="#ffffff"
															fgColor="#000000"
															level="H"
															includeMargin={true}
														/>

														<img
															src="/images/lti_logo.png"
															alt="logo"
															className="payment-qr-logo"
														/>
													</div>

													{qrCode.value && (
														<div className={`payment-countdown-box ${countdown <= 20 ? "is-warning" : ""}`}>
															<div className="payment-countdown-label">
																{t("payment.expireIn") || "QR expires in"}
															</div>
															<div className="payment-countdown-time">
																{formatCountdown(countdown)}
															</div>
														</div>
													)}

													<div className="payment-qr-note">
														{t("payment.scanQrToPay") || "Scan QR code to complete payment"}
													</div>
												</div>

												<div className="payment-summary-section">
													<div className="payment-summary-title">
														{t("contracts.life.paymentDetail") || "Payment details"}
													</div>

													<div className="payment-summary-list">
														<PaymentSummaryRow
															label={t("contracts.life.payPerMonth")}
															value={qrCode?.payPerMonth}
														/>

														<PaymentSummaryRow
															label={t("contracts.life.feeRegister")}
															value={qrCode?.feeRegister}
														/>

														<PaymentSummaryRow
															label={t("contracts.life.paymentFee")}
															value={qrCode?.paymentFee}
														/>

														<PaymentSummaryRow
															label={t("contracts.life.discount")}
															value={qrCode?.discount}
															type="discount"
															prefix="-"
														/>

														<PaymentSummaryRow
															label={t("contracts.life.vatValue")}
															value={qrCode?.vatValue}
														/>

														<PaymentSummaryRow
															label={t("contracts.life.commission")}
															value={qrCode?.commission}
															type="discount"
															prefix="-"
														/>

														<PaymentSummaryRow
															label={t("contracts.life.total")}
															value={qrCode?.total}
															type="total"
														/>

														<PaymentSummaryRow
															label={t("contracts.life.companyReceiveTotal")}
															value={qrCode?.companyReceiveTotal}
															type="receive"
														/>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						) : null}
					</div>
				</section>
			</form>
			<CopyrightFooter />
		</div>
	);
};

export default Index;
